export default "__VITE_ASSET__tWRUlZy5__"